import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AddLocationInfo from './AddLocationInfo'; // Adjust the path as necessary

const stripePromise = loadStripe(process.env.REACT_APP_SUPERADMIN_STRIPE_PUBLIC_KEY || "");

const AddlocationWrapper = (props: any) => (
  <Elements stripe={stripePromise}>
    <AddLocationInfo {...props} />
  </Elements>
);

export default AddlocationWrapper;
